import React, { Suspense, lazy } from 'react';
import Footer from "../components/Footer";
import PreviousDayReturnsGrid from "./Grid/PreviousDayReturnsGrid";
import CancelButton from "../components/Buttons/CancelButton";
import NextOrCompleteButton from "../components/Buttons/NextOrCompleteButton";
import { getReturnTabs, redirectToIBPlanning, emitRefreshTimerEvent } from '../utils';
import withRouter from '../../../../routes/withRouter';
import { getDataWithQueryString } from "./../../../../api/componentAPIs";
import BackButton from "../components/Buttons/BackButton";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withPlanDate } from "../PlanDateContext";
import { sortBy, isEqual } from 'lodash';
// import PastReturnsGrid from './Grid/PastReturnsGrid';
import { AppLoading } from '../../../../loaders/loaders';
import { withAppConfig } from '../../../../appConfigContext';
import { getSpecialNeedsOptionsWithServiceLevel } from '../../utils';
import appConstants from '../../../../appConstants';
import { SHIPMENT_SELECTION_STEPS } from '../constants';
const ProImages = lazy(() => import('@ProImages'));

class Returns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // pastReturns: null,
      // showPastReturns: false,
      showProImagesPopup: false,
      selectedProId: '',
      gridErrorMessage: appConstants.GRID_STATUS.LOADING,
      activeTab: null,
      returnPros: null,
      selectedReturnPros: {}
    };
    this.previousDayReturnsGridApi = null;
    // this.pastReturnsGridApi = null;
    this.isRowDataUpdating = false; // Flag to track when row data is being updated
    this.gridContext = {
      hasProImagesURL: this.hasProImagesURL(),
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.props.serviceLevelList)
    };
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.serviceLevelList, this.props.serviceLevelList)) {
      this.gridContext = {
        specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.props.serviceLevelList)
      };
    }
  }

  componentDidMount() {
    this.getReturnShipmentsForPlan();
  }

  getReturnShipmentsForPlan = (isRefresh = false, shipmentIdsToSelect = []) => {
    const {
      userData: { userProfile },
      planDate
    } = this.props;
    getDataWithQueryString(
      'GetReturnShipmentsForPlan',
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${planDate}`
    ).then(
      (response) => {
        if (response && response.status === 200) {
          const returnProsData = response.data;
          const returnPros = {};
          const selectedReturnPros = {};
          const selectedShipmentIds = isRefresh ? shipmentIdsToSelect : this.props.selectedShipmentIds;
          this.tabs = [];
          let activeTab = '';
          Object.keys(returnProsData).forEach((key) => {
            returnPros[key] = sortBy(returnProsData[key].data, [(item) => !item.isInPlan]);

            const returnProIds = returnPros[key].map((returnPro) => returnPro.proId);
            const selectedFromProps =
              selectedShipmentIds?.filter((selectedPro) =>
                returnProIds.includes(selectedPro)
              ) ?? [];
          
            // isInPlan: Always included (already in plan, cannot be deselected)
            const inPlanIds = returnPros[key]
              .filter((returnPro) => returnPro.isInPlan)
              .map((returnPro) => returnPro.proId);
            
            // isDefaultSelection: Only included on initial load (not on refresh)
            // This allows users to deselect defaults after initial load
            const defaultSelectionIds = isRefresh
              ? []
              : returnPros[key]
                  .filter((returnPro) => returnPro.isDefaultSelection && !returnPro.isInPlan)
                  .map((returnPro) => returnPro.proId);
            
            selectedReturnPros[key] = [...new Set([...selectedFromProps, ...inPlanIds, ...defaultSelectionIds])];

            this.tabs.push({
              tabId: key,
              ...returnProsData[key].metadata,
              totalCount: returnPros[key]?.length
            });

            if (returnProsData[key].metadata?.isActive) {
              activeTab = key;
            }
          });

          emitRefreshTimerEvent(SHIPMENT_SELECTION_STEPS.RETURNS);
          this.setState(
            {
              returnPros,
              selectedReturnPros,
              gridErrorMessage: appConstants.GRID_STATUS.SUCCESS,
              ...(isRefresh ? {} : {activeTab}),
            },
            this.selectReturns
          );
        } else {
          this.handelError();
        }
      },
      (_error) => {
        this.handelError();
      }
    );
  };

  handleRefresh = () => {
    // Refresh the data and keep the selected shipments
    const shipmentIdsToSelect = this.getSelectedReturnPros();
    this.getReturnShipmentsForPlan(true, shipmentIdsToSelect);
  }

  handelError = () => {
    this.props.enqueueSnackbar('Unable to fetch return shipments', {
      variant: 'error'
    });
    this.setState({
      returnPros:null,
      //pastReturns: [],
      gridErrorMessage: appConstants.GRID_STATUS.ERROR
    });
  };

  onPreviousDayReturnsGridReady = (api) => {
    this.previousDayReturnsGridApi = api;
  };

  // onPastReturnsGridReady = ({ api }) => {
  //   this.pastReturnsGridApi = api;
  // };

  selectReturns = () => {
    const returnPros = this.state.selectedReturnPros[this.state.activeTab];
    if (!this.previousDayReturnsGridApi) return;
    
    this.previousDayReturnsGridApi.forEachNode((node) => {
      if (returnPros.includes(node.data.proId) || node.data.isInPlan) {
        node.setSelected(true, false, true); // isSelected, clearOtherSelection, suppressFinishActions
      } else {
        node.setSelected(false, false, true);
      }
    });
  }

  getSelectedReturnPros = () => {
    // Get all selected return pros for the returns section
    return Object.values(this.state.selectedReturnPros).reduce(
      (acc, returnPros) => [...acc, ...returnPros],
      []
    );
  }

  handleNext = () => {
    const selectedReturnPros = this.getSelectedReturnPros();
    this.props.goToNextStep(selectedReturnPros);
  };

  hasProImagesURL = () => {
    return Boolean(this.props.configJSON.proImagesUrl);
  };

  onCellMouseDown = (params) => {
    this.setState({ selectedProId: params.data.proId });
    if (this.hasProImagesURL() && params.column.colId === 'proId') {
      this.updateModalVisibility(true);
    }
  };

  updateModalVisibility = (showProImagesPopup) => {
    this.setState({
      showProImagesPopup
    });
  };

  handleTabChange = (e, activeTab) => {
    if (this.state.activeTab !== activeTab) {
      this.isRowDataUpdating = true;
      this.setState({
        activeTab
      });
    }
  };

  onRowDataUpdated = () => {
    this.isRowDataUpdating = false;
    this.selectReturns();
  };

  onSelectionChanged = ({ api }) => {
    if (this.isRowDataUpdating) {
      // Prevent handling selection changes triggered by row data updates; wait for onRowDataUpdated to finish first.
      return;
    }
    const gridSelectedPros = api.getSelectedRows().map((returnPro) => returnPro.proId);

    // Get always-selected pros (isInPlan items that cannot be deselected)
    const alwaysSelectedPros = [];
    const currentRowData = this.state.returnPros?.[this.state.activeTab] || [];
    currentRowData.forEach((returnPro) => {
      if (returnPro.isInPlan) {
        alwaysSelectedPros.push(returnPro.proId);
      }
    });

    // Combine grid selection with always-selected items
    const newSelectedReturnPros = [...new Set([...gridSelectedPros, ...alwaysSelectedPros])];
    const currentSelectedPros = this.state.selectedReturnPros[this.state.activeTab] || [];
    
    // Only update state if grid selection differs from component state
    // This handles both programmatic changes (states match - ignore) and user changes (states differ - update)
    const compareIds = (a, b) => a.localeCompare(b);
    const sortedNewSelection = [...newSelectedReturnPros].sort(compareIds);
    const sortedCurrentSelection = [...currentSelectedPros].sort(compareIds);
    
    if (!isEqual(sortedNewSelection, sortedCurrentSelection)) {
      this.setState({
        selectedReturnPros: {
          ...this.state.selectedReturnPros,
          [this.state.activeTab]: newSelectedReturnPros
        }
      });
    }
  };

  render() {
    const commonGridProps = {
      onCellMouseDown: this.onCellMouseDown,
      glEventHub: this.props.glEventHub,
      userProfile: this.props.userData.userProfile,
      gridContext: this.gridContext,
      gridErrorMessage: this.state.gridErrorMessage
    };

    return (
      <>
        <PreviousDayReturnsGrid
          rowData={this.state.returnPros?.[this.state.activeTab] ?? null}
          onPreviousDayReturnsGridReady={this.onPreviousDayReturnsGridReady}
          tabList={getReturnTabs(this.tabs, this.state.selectedReturnPros)}
          tabId={this.state.activeTab}
          onTabChange={this.handleTabChange}
          onSelectionChanged={this.onSelectionChanged}
          onRowDataUpdated={this.onRowDataUpdated}
          handleRefresh={this.handleRefresh}
          // handleShowPastReturnsClick={this.handleShowPastReturnsClick}
          // showPastReturns={this.state.showPastReturns}
          {...commonGridProps}
        />

        {/* <PastReturnsGrid
          showPastReturns={this.state.showPastReturns}
          rowData={this.state.pastReturns}
          onGridReady={this.onPastReturnsGridReady}
          {...commonGridProps}
        /> */}

        <Footer>
          <CancelButton onClick={redirectToIBPlanning(this.props.router.navigate)} />
          <BackButton onClick={this.props.goBack} />
          <NextOrCompleteButton onClick={this.handleNext} disabled={!this.state.returnPros} />
        </Footer>

        <Suspense fallback={<AppLoading />}>
          {this.state.showProImagesPopup && (
            <ProImages
              proNumber={this.state.selectedProId}
              show={this.state.showProImagesPopup}
              onClose={() => {
                this.updateModalVisibility(false);
              }}
            />
          )}
        </Suspense>
      </>
    );
  }
}

export default compose(
  withPlanDate,
  withSnackbar,
  withUserProfile,
  withAppConfig,
  withRouter
)(Returns);
